

 function updateWishlistCounter() {

    var cookieName = "wishlistList";

    var cookieVal = jQuery.cookie(cookieName);



    if (cookieVal && cookieVal != '__' && cookieVal != '') {

      var items = cookieVal.split("__").filter(function(el) {

        return el != '';

      });

      jQuery(".wishlist-counter").text(items.length);

    } else {

      jQuery(".wishlist-counter").text(0);

    }

  }



  // Page load hone ke baad update

  jQuery(document).ready(function(){

    updateWishlistCounter();



    // jab bhi product wishlist me add ho ya remove ho, turant update

    jQuery(document).on("click", ".add-to-wishlist, .product-remove-js", function(){

      setTimeout(function(){

        updateWishlistCounter();

      }, 300);

    });

  });